/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { useIntl } from 'react-intl';

import { Link } from 'react-router-dom';

import { getOriginalPicture } from '@braindate/util/lib/image';
import {
  getEventLogoAltText,
  getEventLogo,
} from '@braindate/domain/lib/event/util';
import useEvent from 'src/shared/domain/event/hook/useEvent';

import BraindateBrandedLogoIcon from 'src/shared/ui/component/icon/BraindateBrandedLogoIcon';
import messages from 'src/shared/app/nav/l10n/navigationL10n';

import styles from './Branding.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';
import ResponsivePicture from '@braindate/ui/lib/component/ResponsivePicture';
import useRoutes from 'src/shared/app/base/route/hook/useRoutes';
import { homeRoute } from 'src/shared/app/base/route/setting/routeSettings';

const useStyles = createUseThemeStyles(styles);

type Props = {
  className?: string,
};

const Branding = ({ className }: Props): React.Node => {
  const intl = useIntl();

  const event = useEvent();
  const logo = getEventLogo(event, intl.locale);
  const logoAltText = getEventLogoAltText(event, intl.locale);

  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const [homePath] = useRoutes(homeRoute);

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles();

  const rootClasses = classNames(classes.root, className);

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  const hasLogo = !!logo && !!getOriginalPicture(logo);

  return (
    <Link
      className={rootClasses}
      to={homePath}
      aria-label={intl.formatMessage(messages.homePage)}
    >
      {hasLogo ? (
        <>
          {/* {textElt} */}
          <ResponsivePicture
            layoutClass={classes.logo}
            picture={logo}
            alt={logoAltText}
          ></ResponsivePicture>
        </>
      ) : (
        <BraindateBrandedLogoIcon className={classes.braindateLogo} />
      )}
    </Link>
  );
};

export const large = Symbol();
export const xlarge = Symbol();

export default compose(React.memo)(Branding);
